<div class="open-link-wrapper">
  <img *ngIf="data?.img" [src]="data?.img" alt="" width="120px" [ngStyle]="{'width': data?.width ? data?.width: '120px'}">
  <p>{{'redirect-dialog.title' | translate}}</p>
  <div class="button-wrapper d-flex justify-content-end gap-3">
    <button class="btn btn-outline-primary" type="button" (click)="cancel()">{{'redirect-dialog.cancel' | translate}}</button>
    <button class="btn btn-primary" (click)="redirect()">{{'redirect-dialog.ok' | translate}}</button>
  </div>
</div>